import React from 'react';
import '../styles/QuemSomos.css';

function QuemSomos() {
  return (
    <div className="quem-somos-container">
      <div className="quem-somos-header">
        <h1>Quem Somos</h1>
        <p>Somos uma empresa especializada na produção de Palha Italiana, oferecendo os melhores sabores e ingredientes para você.</p>
      </div>
      <div className="quem-somos-content">
        <p>Com uma tradição que valoriza a qualidade e o sabor, buscamos trazer para você o melhor da Palha Italiana, feita com carinho e dedicação.</p>
      </div>
    </div>
  );
}

export default QuemSomos;
